import OwnerAssignment from "../../StateMachine/OwnerAssignment";
import AccessTemplateSelection from "../../../components/BuilderComponents/AccessTemplateSelection";

const HttpRawPermissions = ({ selectedApiData, setSelectedApiData }) => {
  const settingOwnerAssignment = (data) => {
    setSelectedApiData({
      ...selectedApiData,
      permissions: data
    });
  };

  const handleChangeAccessTemplate = (data) => {
    setSelectedApiData({
      ...selectedApiData,
      permissions: {
        ...selectedApiData?.permissions,
        access_templates: data
      }
    });
  };
  return (
    <>
      <OwnerAssignment
        ownerAssignment={selectedApiData?.permissions}
        setOwnerAssignment={settingOwnerAssignment}
        style={{ height: "auto" }}
        className=""
      />
      <AccessTemplateSelection
        templates={setSelectedApiData?.permissions?.access_templates}
        handleChange={handleChangeAccessTemplate}
        className="mt_3"
      />
    </>
  );
};

export default HttpRawPermissions;
